// Public support address. Override at build time with VITE_SUPPORT_EMAIL.
// Never fall back to a personal Gmail.
export const DEFAULT_SUPPORT_EMAIL = 'support@master-splitter.com';

const viteEmail = typeof import.meta.env !== 'undefined'
  ? import.meta.env.VITE_SUPPORT_EMAIL
  : undefined;

export const SUPPORT_EMAIL = (
  viteEmail || DEFAULT_SUPPORT_EMAIL
).trim() || DEFAULT_SUPPORT_EMAIL;

export function fillSupportEmail(value, email = SUPPORT_EMAIL) {
  if (typeof value === 'string') return value.replaceAll('{{supportEmail}}', email);
  if (Array.isArray(value)) return value.map((item) => fillSupportEmail(item, email));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [key, fillSupportEmail(nested, email)]),
    );
  }
  return value;
}
